
















import { Component, Vue, Prop } from 'vue-property-decorator'
import BoxTitle from './BoxTitle.vue'
import { priSubPath } from '@/apps/open/constants/index'

@Component({
  components: {
    BoxTitle
  }
})

export default class ProduceExp extends Vue {
  @Prop()
  exps!: object

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  jumpLink (link: string) {
    if (link === '/kdocs') {
      const subPath = priSubPath
      window.open(`${location.origin}${subPath}/kdocs`)
    } else {
      window.open(link)
    }
  }
}

